import React, {useEffect, useState} from 'react';

import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';

import {getSchemaFieldCounts} from './UnitDictionaryDAO';

interface UnitArchiveWarningBannerProps {
  unitIds: Array<string>;
  entityLabel: 'unit' | 'unitType';
}

export default function UnitArchiveWarningBanner({
  unitIds,
  entityLabel,
}: UnitArchiveWarningBannerProps): JSX.Element | null {
  const [loading, setLoading] = useState(true);
  const [schemaFieldCount, setSchemaFieldCount] = useState(0);

  useEffect(() => {
    getSchemaFieldCounts(unitIds)
      .then((response) => {
        setSchemaFieldCount(response.schemaFieldCount);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console -- intentional: log warning without blocking archive
        console.warn('Failed to fetch schema field counts for unit archive warning', err);
      })
      .finally(() => {
        setLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- fetch once on mount
  }, []);

  if (loading) {
    return <CenteredHorizontalThrobber />;
  }

  if (schemaFieldCount === 0) {
    return null;
  }

  const plural = schemaFieldCount !== 1;
  let message: string;
  if (entityLabel === 'unit') {
    message = `${schemaFieldCount} schema field definition${plural ? 's' : ''} referencing this unit will also be archived.`;
  } else {
    message = `${schemaFieldCount} schema field definition${plural ? 's' : ''} referencing units in this type will also be archived.`;
  }

  return <InlineBanner bannerType={InlineBannerType.WARNING} text={message} />;
}
